import { useEffect, useState } from "react";
import styled from "styled-components";
import logo from "../../images/logo.jpg";
import { Link, useLocation } from "react-router-dom";

/* ================= STYLES ================= */

const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #0b0c0f;
  padding: 0.5rem 1rem;
  position: fixed;
  top: ${({ $visible }) => ($visible ? "0" : "-100px")};
  left: 0;
  width: 100%;
  transition: top 0.3s ease;
  z-index: 9999;
`;

const Logo = styled.img`
  height: 50px;
`;

const NavList = styled.ul`
  display: flex;
  list-style: none;
  gap: 1.2rem;

  @media (max-width: 900px) {
    height: 100dvh;
    margin-top: -5px;
    position: absolute;
    top: 70px;
    left: 0;
    width: 100%;
    flex-direction: column;
    justify-content: space-evenly;
    text-align: center;
    background-color: #0b0c0f;
    padding: 2rem 1rem;
    transform: ${({ $open }) =>
      $open ? "translateY(0)" : "translateY(-20px)"};
    opacity: ${({ $open }) => ($open ? 1 : 0)};
    pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
    transition: 0.3s ease;
  }
`;

const NavItem = styled.li`
  a {
    color: ${({ $active }) => ($active ? "#b42323ff" : "white")};
    text-decoration: none;
    font-size: 16px;

    &:hover {
      color: #b42323ff;
    }
  }
`;

const Hamburger = styled.div`
  display: none;
  width: 30px;
  height: 22px;
  position: relative;
  cursor: pointer;

  @media (max-width: 900px) {
    display: block;
  }

  span {
    position: absolute;
    height: 3px;
    width: 100%;
    background: white;
    left: 0;
    transition: 0.3s;
  }

  span:nth-child(1) {
    top: ${({ $open }) => ($open ? "9px" : "0")};
    transform: ${({ $open }) => ($open ? "rotate(45deg)" : "none")};
  }

  span:nth-child(2) {
    top: 9px;
    opacity: ${({ $open }) => ($open ? 0 : 1)};
  }

  span:nth-child(3) {
    top: ${({ $open }) => ($open ? "9px" : "18px")};
    transform: ${({ $open }) => ($open ? "rotate(-45deg)" : "none")};
  }
`;

export const Act = styled.h2`
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  user-select: none;
  cursor: default;
  
    @media (max-width: 900px) {
    font-size: 16px;
  }
`;

/* ================= COMPONENT ================= */

export const TopBar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");
  const [visible, setVisible] = useState(true);
  const [lastScroll, setLastScroll] = useState(0);

  /* aktywna zakładka */
  useEffect(() => {
    if (pathname.includes("renowacja")) setActive("Renowacja Felg");
    else if (pathname.includes("malowanie")) setActive("Malowanie Proszkowe");
    else if (pathname.includes("wynajem")) setActive("Wynajem");
    else setActive("Strona Główna");
  }, [pathname]);

  /* chowanie paska przy scrollu */
  useEffect(() => {
    const onScroll = () => {
      if (window.innerWidth < 900) {
        setVisible(true);
        return;
      }

      const current = window.scrollY;
      setVisible(current < lastScroll);
      setLastScroll(current);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [lastScroll]);

  const closeMenu = () => setOpen(false);

  return (
    <Nav $visible={visible}>
      <div
        style={{
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <Link to="/strona-glowna" onClick={closeMenu}>
          <Logo src={logo} alt="logo" />
        </Link>
        <Act>{active}</Act>
      </div>

      <Hamburger $open={open} onClick={() => setOpen(!open)}>
        <span />
        <span />
        <span />
      </Hamburger>

      <NavList $open={open}>
        <NavItem $active={active === "Strona Główna"}>
          <Link to="/strona-glowna" onClick={closeMenu}>
            Strona główna
          </Link>
        </NavItem>

        <NavItem $active={active === "Renowacja Felg"}>
          <Link to="/renowacja-felg" onClick={closeMenu}>
            Renowacja felg
          </Link>
        </NavItem>

        <NavItem $active={active === "Malowanie Proszkowe"}>
          <Link to="/malowanie-proszkowe" onClick={closeMenu}>
            Malowanie proszkowe
          </Link>
        </NavItem>

        <NavItem $active={active === "Wynajem"}>
          <Link to="/wynajem" onClick={closeMenu}>
            Wynajem
          </Link>
        </NavItem>
      </NavList>
    </Nav>
  );
};
